import React from 'react';
import { motion } from 'framer-motion';
import { Info } from 'lucide-react';
export function CostBreakdown() {
  const rows = [{
    item: 'Precio del vehículo (Subasta)',
    cost: 4220
  }, {
    item: 'Grúa (USA)',
    cost: 285
  }, {
    item: 'Flete marítimo (USA -> SV)',
    cost: 775
  }, {
    item: 'Seguro de carga',
    cost: 55.1
  }, {
    item: 'DAI (Impuesto de importación)',
    cost: 1333.78
  }, {
    item: 'AIV',
    cost: 53.35
  }, {
    item: 'IVA',
    cost: 866.95
  }, {
    item: 'Gestión aduanal y trámites',
    cost: 350.26
  }, {
    item: 'Servicio',
    cost: 250,
    highlight: true
  }];
  const total = rows.reduce((acc, row) => acc + row.cost, 0);
  return <section id="costs" className="py-20 bg-earia-bg-alt border-y border-earia-border" data-id="element-13">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14">
        <div className="text-center mb-12" data-id="element-15">
          <h2 className="text-3xl md:text-4xl font-bold text-earia-text-heading mb-4" data-id="element-16">
            Desglose de costos real
          </h2>
          <p className="text-earia-text-body text-lg" data-id="element-17">
            Ejemplo real de una importación reciente de un Nissan Sentra 2021.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-earia-card rounded-xl border border-earia-border overflow-hidden shadow-lg" data-id="element-18">
          <div className="overflow-x-auto" data-id="element-19">
            <table className="w-full text-left border-collapse" data-id="element-20">
              <thead data-id="element-21">
                <tr className="bg-earia-bg border-b border-earia-border" data-id="element-22">
                  <th className="py-4 px-6 text-sm font-medium text-earia-text-body uppercase tracking-wider" data-id="element-23">
                    Concepto
                  </th>
                  <th className="py-4 px-6 text-sm font-medium text-earia-text-body uppercase tracking-wider text-right" data-id="element-24">
                    Monto (USD)
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-earia-border" data-id="element-25">
                {rows.map((row, index) => <tr key={index} className={`hover:bg-earia-bg transition-colors ${row.highlight ? 'bg-earia-accent/5' : ''}`} data-id="element-26">
                    <td className={`py-4 px-6 text-sm ${row.highlight ? 'text-earia-accent-hover font-medium' : 'text-earia-text-heading'}`} data-id="element-27">
                      {row.item}
                    </td>
                    <td className={`py-4 px-6 text-sm font-mono text-right ${row.highlight ? 'text-earia-accent-hover font-bold' : 'text-earia-text-heading'}`} data-id="element-28">
                      ${row.cost.toLocaleString()}
                    </td>
                  </tr>)}

                {/* Subtotal Row */}
                <tr className="bg-earia-bg/50" data-id="element-29">
                  <td className="py-4 px-6 text-sm font-bold text-earia-text-heading text-right" data-id="element-30">
                    Subtotal
                  </td>
                  <td className="py-4 px-6 text-sm font-mono font-bold text-earia-text-heading text-right" data-id="element-31">
                    ${total.toLocaleString()}
                  </td>
                </tr>

                {/* Total Row */}
                <tr className="bg-earia-accent" data-id="element-32">
                  <td className="py-5 px-6 text-lg font-bold text-earia-text-heading text-right" data-id="element-33">
                    TOTAL FINAL
                  </td>
                  <td className="py-5 px-6 text-xl font-mono font-bold text-earia-text-heading text-right" data-id="element-34">
                    $8,221.94
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </motion.div>

        <div className="mt-6 flex items-start gap-3 text-earia-text-body text-sm bg-earia-card p-4 rounded-lg border border-earia-border shadow-sm" data-id="element-35">
          <Info className="w-5 h-5 flex-shrink-0 text-earia-accent-hover" data-id="element-36" />
          <p data-id="element-37">
            Los costos presentados son estimados basados en una importación
            real. Los valores de subasta, impuestos y fletes pueden variar según
            el tipo de vehículo, ubicación en USA y valor de compra.
          </p>
        </div>
      </div>
    </section>;
}